import { SPARK } from '../cards/recursive/spark';
import { HEX_WEAKEN } from '../cards/support/hex-weaken';
import { VENOM } from '../cards/support/venom';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Common tier: 2×2, 2 dice. Pure attrition —
 * barely scratches you directly, but the random-valid AI feeds poison + weaken
 * often enough to grind a careless player down. Coherent at common precisely
 * because random-valid gives its status cards a fair draw. */
export const FEN_LURKER: EnemyTemplate = {
  id: 'fen-lurker',
  name: 'Fen Lurker',
  glyph: '♨', // rising bog steam
  tier: 'common',
  hp: 14,
  loadout: [
    { card: VENOM, origin: { row: 0, col: 0 }, rotated: false },
    { card: HEX_WEAKEN, origin: { row: 0, col: 1 }, rotated: false },
    { card: SPARK, origin: { row: 1, col: 1 }, rotated: false },
  ],
  drops: { gold: 3 },
};
